import { render } from "./WindowsController.vue?vue&type=template&id=ebb80bd6"
import script from "./WindowsController.vue?vue&type=script&lang=js"
export * from "./WindowsController.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__